export default __webpack_public_path__ + "static/media/mindMap.730f4395.svg";